import {
  QueryWorkOrdersOrderByColumn,
  SortOrder,
  WorkOrderListQueryVariables,
  WorkOrderStatus,
} from "@/gql/graphql";

export function getWorkOrderListQueryVariables({
  search,
  status,
  supplierId,
}: {
  search?: string;
  status?: WorkOrderStatus[];
  supplierId?: string | null;
}): WorkOrderListQueryVariables {
  return {
    page: 1,
    first: 20,
    search: search || undefined,
    status: status?.length ? status : undefined,
    supplier_id: supplierId ?? undefined,
    orderBy: [
      {
        column: QueryWorkOrdersOrderByColumn.CreatedAt,
        order: SortOrder.Desc,
      },
    ],
  };
}
